export default (function (obj, key) { return obj.hasOwnProperty(key); });
//# sourceMappingURL=has.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.9@@antv/util/esm/has.js
// module id = null
// module chunks = 